import React from 'react';
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { unregisterDashboardPushToken } from '../firebase/firebaseMessaging';

function Sidebar({ isOpen, isMobile, onClose }) {
    const navigate = useNavigate();
    const role = localStorage.getItem('role'); // e.g., 'main-admin' for main admins

    const handleLogout = async () => {
        await unregisterDashboardPushToken();
        localStorage.removeItem('token'); // ✅ Remove token
        localStorage.removeItem('role');
        navigate('/login');               // ✅ Redirect to login
    };

    const handleLinkClick = () => {
        // Always close sidebar when a link is clicked for better space utilization
        if (onClose) {
            onClose();
        }
    };

    const sidebarStyle = {
        height: 'calc(100vh - 56px)', // Full height minus navbar
        width: '240px',
        position: 'fixed', // Always fixed position for both mobile and desktop
        top: '56px', // Position below the navbar
        right: isMobile ? (isOpen ? 0 : '-240px') : (isOpen ? 0 : '-240px'), // Hide when closed on both
        zIndex: 1040, // Below navbar but above content
        transition: 'right 0.3s ease',
        transform: 'none',
        overflowY: 'auto', // Enable vertical scrolling
        overflowX: 'hidden' // Prevent horizontal scrolling
    };

    return (
        <div className="bg-white border-end" style={sidebarStyle}>
            <div className="p-3" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* Close button and header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="text-primary mb-0">لوحة التحكم</h5>
                    <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={onClose}
                        style={{ padding: '5px 10px' }}
                    >
                        ✕
                    </button>
                </div>

                {/* Scrollable navigation area */}
                <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '10px' }}>
                    <ul className="nav flex-column">
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/vendors" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                🏬 البائعين
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/categories" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                📂 الفئات
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/all-products" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                📦 جميع المنتجات
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink
                                to="/dashboard/coupons"
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                🎟️ الكوبونات
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink
                                to="/dashboard/bundle-deals"
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                🧺 عروض الحزم
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink
                                to="/dashboard/delivery-zones"
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                🗺️ مناطق التوصيل
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink
                                to="/dashboard/delivery-config"
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                ⚙️ إعدادات التوصيل
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink
                                to="/dashboard/users" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                👥 المستخدمين
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/pending-admins" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                👤 المسؤولون المعلقون
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/active-orders" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                🚚 الطلبات النشطة
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/admin-orders" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                ⚡ إدارة الطلبات
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/slider-management" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                🖼️ إدارة صور الرئيسية
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/app-versions" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                📱 إدارة الإصدارات
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/register-driver" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                🚗 تسجيل سائق
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink
                                to="/dashboard/driver-requests"
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                📞 طلبات سائق من المتاجر
                            </NavLink>
                        </li>
                        <li className="nav-item mb-2">
                            <NavLink 
                                to="/dashboard/drivers-list" 
                                className="nav-link text-dark"
                                onClick={handleLinkClick}
                            >
                                📝 قائمة السائقين
                            </NavLink>
                        </li>
                        {/* Only show order analytics for main admins */}
                        {role === 'main-admin' && (
                            <li className="nav-item mb-2">
                                <NavLink 
                                    to="/dashboard/order-stats" 
                                    className="nav-link text-dark"
                                    onClick={handleLinkClick}
                                >
                                    📊 إحصائيات الطلبات
                                </NavLink>
                            </li>
                        )}
                    </ul>
                </div>

                {/* Fixed logout button at bottom */}
                <div style={{ marginTop: 'auto', paddingTop: '15px', borderTop: '1px solid #eee' }}>
                    <button 
                        className="btn btn-outline-danger w-100" 
                        onClick={handleLogout}
                        style={{ fontSize: '14px' }}
                    >
                        🚪 تسجيل الخروج
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
